import React from "react";
import { useNavigate } from "react-router-dom";

import { Mobile, NotMobile } from "../../../common/Responsive";
import { BaseHeader } from "../../../components/layout/headerComponents/baseHeader/BaseHeader";
import { WizardHeaderLogo } from "../../../components/layout/headerComponents/headerLogo/HeaderLogo";
import { HeaderTitle } from "../../../components/layout/headerComponents/headerTitle/HeaderTitle";
import { WizardHeaderUserMenu } from "../../../components/layout/headerComponents/headerUserMenu/WizardHeaderUserMenu";
import { GoPrevStep } from "../goPrevStepButton/GoPrevStepButton";

import "./WizardHeader.scss";

export const WizardHeader = () => {
  const navigate = useNavigate();

  return (
    <BaseHeader className="wizard-header">
      <NotMobile>
        <div className="wizard-header__content-left">
          <WizardHeaderLogo />
          <HeaderTitle />
        </div>
      </NotMobile>
      <Mobile>
        <div className="wizard-header__content-left">
          <GoPrevStep onClick={() => navigate(-1)} />
        </div>
      </Mobile>
      <div className="wizard-header__content-right">
        <WizardHeaderUserMenu />
      </div>
    </BaseHeader>
  );
};
